import angular from 'angular';
import SendComponent from './components/send';
import subscribersComponent from './components/subscribers';
import {NewsletterConfig} from './components/newsletter.config';
import uiRouter from 'angular-ui-router';
import Newsletter from './services/newsletter.service';
import NewsletterDataProvider from './services/newsletter.dataprovider.service';

export default angular.module('newsletters', [uiRouter])
  .component('newsletter', SendComponent)
  .component('subscriberListing', subscribersComponent)
  .service('Newsletter', Newsletter)
  .service('NewsletterDataProvider', NewsletterDataProvider)
  .config(NewsletterConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/newsletter/index.js
 **/